import { useEffect, useState, Fragment, useRef } from 'react'
import { useIntl } from 'react-intl'
// HTML to TEXT plugin to show the editor content as a bare text
import { compile } from 'html-to-text'
import { Color, LuxButton } from '@lux/wardrobe-lib'
import { NewsItemContentProps } from '@models/news'
import { BareHtml } from '../../BareHtml/BareHtml'

const NewsItemContent = (props: NewsItemContentProps) => {
    const { title, content, openActivity, showAllContent } = props

    const intl = useIntl()
    const contentRef = useRef(null)

    const maxChar = 90
    // const [maxChar, setMaxChar] = useState<number>(450)
    const [hasShowMore, setHasShowMore] = useState<boolean>(false)

    const newsItemContentClass = 'home-news-item-content'

    const showTextHandler = () => {
        hasShowMore && props.onReadMore()
    }

    // const updateMaxChar = () => {
    //     if (window.innerWidth < 768) {
    //         setMaxChar(window.innerWidth / 2.5)
    //     } else if (window.innerWidth > 767 && window.innerWidth < 992) {
    //         setMaxChar(window.innerWidth / 7.5)
    //     } else {
    //         setMaxChar(window.innerWidth / 5)
    //     }
    // }

    // useEffect(() => {
    //     updateMaxChar()
    //     const handleResize = () => {
    //         updateMaxChar()
    //     }
    //     window.addEventListener('resize', handleResize, false)
    // }, [])

    useEffect(() => {
        if (contentRef.current) {
            const clientHeight = contentRef.current.clientHeight
            const scrollHeight = contentRef.current.scrollHeight
            setHasShowMore(clientHeight !== scrollHeight)
        }
    }, [contentRef])

    // const stripTagsFroala = (str: string) => {
    //     let stripTags = str.replace(/(<([^>]+)>)/gi, '')
    //     let stripFroala = stripTags.replace('Powered by Froala Editor', '')
    //     return stripFroala
    // }

    let textElement = () => (
        <Fragment>
            <BareHtml.div
                innerHTML={{
                    __html:
                        htmlToText(content).length > maxChar
                            ? htmlToText(content).slice(0, maxChar) + '...  '
                            : htmlToText(content),
                }}
            />
            <LuxButton
                text={intl.formatMessage({
                    id: 'home.news.read.more',
                    defaultMessage: 'Read all',
                })}
                variant="text"
                color={Color.BLUE}
                onClick={openActivity}
                classes={`${newsItemContentClass}__read-link`}
            />
            {/* <span onClick={openActivity} className={`${newsItemContentClass}__read-link`}>
                {intl.formatMessage({
                    id: 'home.news.read.more',
                    defaultMessage: 'Read all',
                })}
            </span> */}
        </Fragment>
    )

    // config for the next function
    const convert = compile({
        wordwrap: 90,
        ignoreHref: true,
        selectors: [
            { selector: 'img', format: 'skip' },
            { selector: 'video', format: 'skip' },
        ],
    })

    // removes html tags images and videos
    const htmlToText = (html: string) => {
        const result = convert(html)
        return result
    }

    return (
        <div className={newsItemContentClass}>
            <div
                onClick={showTextHandler}
                className={`${newsItemContentClass}__title text-bold ${
                    hasShowMore ? 'has-show-more' : ''
                }`}>
                {title}
            </div>
            <div
                ref={contentRef}
                onClick={showTextHandler}
                // className={`${newsItemContentClass}__text text`}
                className={`${newsItemContentClass}__text text ${
                    hasShowMore ? 'has-show-more' : ''
                }`}
                // style={
                //     !props.showAllContent
                //         ? {
                //               //   WebkitLineClamp: 3,
                //           }
                //         : {}
                // }
            >
                {textElement()}
                {/* <BareHtml.div innerHTML={{ __html: htmlToText(content) }} /> */}
            </div>
            {/* {hasShowMore && (
                <span className={`${newsItemContentClass}__read-link`} onClick={showTextHandler}>
                    {intl.formatMessage({
                        id: !props.showAllContent ? 'home.news.read.more' : 'home.news.read.less',
                        defaultMessage: !props.showAllContent ? 'Read all' : 'Read less',
                    })}
                </span>
            )} */}
        </div>
    )
}

export default NewsItemContent
